"use strict"

import React, { useEffect, useState } from "react"

import { ConfirmEditedResource } from "./ModalParts"
import EditResourceModal, { DisabledTextInput } from "./EditResourceModal"
import { FormattedMessage } from "react-intl"

export default function EditDCSTablesModal(props) {
  const [tables, setTables] = useState([])
  useEffect(() => {
    setTables(props.tables)
  }, [props.tables])

  const disableEditing = (table) => ["Deleting", "Error"].includes(table["status"]) || table.pseudo_table

  const table_info = [
    {
      header_id: "general.name",
      key: "name",
      style: (table) => {
        return ""
      },
      content: (table, idx, updateFormValue, list) => {
        return <DisabledTextInput value={table.name} />
      },
    },
    {
      header_id: "general.description",
      key: "description",
      style: (table) => {
        return ""
      },
      content: (table, idx, updateFormValue, list) => {
        return (
          <textarea
            className={"input-full-width text-center"}
            name={"description"}
            disabled={disableEditing(table)}
            value={table.description || ""}
            onChange={(e) => updateFormValue(e, "description", e.target.value, idx, table.warning)}
          />
        )
      },
    },
    {
      header_id: "reactormanagement.timestamp.column",
      key: "timestamp_column",
      style: (table) => {
        if (table.edited) {
          return "table_edited"
        } else if (!table["valid_timestamp_column"] && table.active) {
          return "table_warning"
        } else {
          return "table_okay"
        }
      },
      content: (table, idx, updateFormValue, list) => {
        return (
          <select
            className={"form-select form-select-sm"}
            name={"timestamp_column"}
            value={table.timestamp_column}
            disabled={disableEditing(table)}
            onChange={(e) => updateFormValue(e, "timestamp_column", e.target.value, idx, table.warning)}
          >
            {table.timestamp_options.map((opt, i) => {
              return (
                <option key={i} value={opt}>
                  {opt}
                </option>
              )
            })}
          </select>
        )
      },
    },
    {
      header_id: "general.active",
      key: "active",
      style: (table) => {
        return ""
      },
      content: (table, idx, updateFormValue, list) => {
        return (
          <h5>
            <input
              type={"checkbox"}
              key={Math.random()} // To force rerender of checkbox on change
              disabled={disableEditing(table)}
              checked={table.active}
              onChange={(e) => updateFormValue(e, "active", !table.active, idx, table.warning)}
            />
          </h5>
        )
      },
    },
    {
      header_id: "general.status",
      key: "status",
      style: (table) => {
        return ""
      },
      content: (table, idx, updateFormValue, list) => {
        if (table["status"] === "Inspecting") {
          return (
            <h5>
              <span className={"fa fa-refresh text-info"} />
            </h5>
          )
        } else if (table["status"] === "Error") {
          return (
            <h5 className={"table_warning"}>
              <span className={"fa fa-times-circle-o text-danger"} />
            </h5>
          )
        } else if (table["status"] === "Deleting") {
          return (
            <h5>
              <span className={"fa fa-trash-o text-danger"} />
            </h5>
          )
        } else {
          return (
            <h5>
              <span className={"fa fa-check-circle-o text-success"} />
            </h5>
          )
        }
      },
    },
  ]

  return (
    <EditResourceModal
      editable_fields={["active", "description", "timestamp_column"]}
      fields_to_complete={[]}
      resources={tables}
      step_into_resources={false}
      table_title={
        <h5>
          <FormattedMessage id={"reactormanagement.managedcstables"} description={"Edit DCSTables"} />:{" "}
          {props.source.name}
        </h5>
      }
      additionalValidationCheck={false}
      submitData={(data, loaderRef) => props.submitData(data, loaderRef)}
      ModalPart={ConfirmEditedResource}
      modal_title_id={"navigation.source.registration"}
      resource_name={"Edit DCSTables"}
      table_info={table_info}
      table_row_style={(table) => {
        if (table.edited) {
          return "table_edited"
        } else {
          return "table_okay"
        }
      }}
      initial_tag_state={(table) => {
        return { edited: false, warning: false, complete: false }
      }}
      warning={props.warning}
      show={props.show}
      onHide={props.onHide}
    />
  )
}
